import React from "react";

const MAP = {
  expired: { label: "Süresi Doldu", cls: "bg-red-100 text-red-800 border-red-200" },
  critical: { label: "Kritik", cls: "bg-orange-100 text-orange-800 border-orange-200" },
  upcoming: { label: "Yaklaşıyor", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  ok: { label: "Zamanında", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
};

export function StatusBadge({ status, testid }) {
  if (!status) return <span className="text-xs text-slate-400">—</span>;
  const m = MAP[status.state] || MAP.ok;
  const days = status.days_left;
  const daysTxt = days < 0 ? `${Math.abs(days)} gün geçti` : `${days} gün kaldı`;
  return (
    <span
      data-testid={testid || `deadline-badge-${status.state}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ${m.cls}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {m.label} · {daysTxt}
    </span>
  );
}

export default StatusBadge;
